import crypto from 'crypto';
import { Buffer } from 'buffer';

const { VITE_APP_SECRET = '', VITE_APP_SALT = '' } = import.meta.env;
export function decrypt(hashedString: string): string | null {
  try {
    const resizedIV = Buffer.allocUnsafe(16);
    const iv = crypto.createHash('sha256').update(`${VITE_APP_SECRET}${VITE_APP_SALT}`).digest();
    iv.copy(resizedIV);

    const key = crypto.createHash('sha256').update(VITE_APP_SECRET).digest();

    const decipher = crypto.createDecipheriv('aes256', key, resizedIV);
    const msg = [];
    msg.push(decipher.update(hashedString, 'hex', 'binary'));
    msg.push(decipher.final('binary'));

    return msg.join('');
  } catch (err) {
    console.error(err);
    throw err;
  }
}
